export default "__VITE_ASSET__ErRDzkj1__"